import React from 'react';
import { EventHubModulePage, EventHubsVM } from './event-hubs.viewmodel';
import { EventHubsList } from './_event-hubs-list/event-hubs-list';
import { observer } from 'mobx-react';
import { ManageEventHub } from './_manage-event-hub/manage-event-hub';
import { EventHubWebsiteBuilder } from './_event_hub-website-builder/event-hub-website-builder';
import { RestrictedContent } from '../_restricted-content/restricted-content';
import { Permission } from '../../api/roles.dao';

export type EventHubsPresentationProps = {
    vm: EventHubsVM;
};

export const EventHubsPresentation = observer(({ vm }: EventHubsPresentationProps) => {
    switch (vm.getEventHubModulePage()) {
        case EventHubModulePage.EventHubsList:
            return <EventHubsList />;
        case EventHubModulePage.ManageEventHub:
            return <ManageEventHub />;
        case EventHubModulePage.EventHubWebsiteBuilder:
            return <RestrictedContent
                content={<EventHubWebsiteBuilder />}
                permission={Permission.HUB_WEBSITE_BUILDER}
            />;
        default:
            return null;
    }
});